// prismjs color theme
import './src/styles/prism.css';

// Import custom Prism language definitions
import './src/utils/prism-vyper';

// Import Amplify configuration
import configureAmplify from './src/utils/amplify';

// Run when DOM is ready
export const onClientEntry = () => {
  // Initialize AWS Amplify
  configureAmplify();
}